import { createContext, useContext } from "react";

/**
 * Контекст для переопределения SEO-метаданных прокси-страницей.
 * Значения: { title, description, keywords, canonicalUrl }
 */
const ProxyPageOverrideContext = createContext(null);

export function useProxyPageOverride() {
  return useContext(ProxyPageOverrideContext);
}

export default ProxyPageOverrideContext;
